export const BUS_AIRCRAFT_CODE = 'BUS';

export const GENDER_OPTIONS = ['mr', 'ms'];

export enum Title {
  MS = 'Ms.',
  MRS = 'Mrs.',
  MR = 'Mr.',
}
